/**
 * 数字报分类管理
 */
import { createAPI } from '@common'

export default {
  // 数字报分类管理-获取分组列表
  getGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0dbut', 'get', config),
  // 数字报分类管理-添加分组列表
  postGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0dbut', 'post', config),
  // 数字报分类管理-修改分组列表
  putGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0dbut', 'put', config),
  // 数字报分类管理-删除分组列表
  deleteGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0dbut0efmfuf', 'post', config),
  // 数字报分类管理-数字报报纸
  getPaperAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfsTfu0bmm', 'get', config),
  // 数字报分类管理-数字报排序
  gostPaperOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0dbut0psefs!', 'post', config),
  // 数字报分类设置-数字报报纸（受权限控制）
  getReleaseRuleData: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0f60mjtuebub', 'post', config, vconfig)
}
